<script setup lang="ts">
import SVGWhatsApp from '@/components/svg/SVGWhatsApp.vue';

defineProps<{
    title: string;
    subtitle?: string;
    statusLabel?: string;
    statusVariant?: string;
    summary?: string;
}>();
</script>

<template>
    <header class="rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
        <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex min-w-0 items-center gap-3.5">
                <span
                    class="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-emerald-100 bg-emerald-50"
                >
                    <SVGWhatsApp class="h-7 w-7 text-[#25D366]" />
                </span>
                <div class="min-w-0">
                    <div class="flex flex-wrap items-center gap-2.5">
                        <h1 class="truncate text-xl font-bold tracking-tight text-gray-900">
                            {{ title }}
                        </h1>
                        <UiBadge v-if="statusLabel" :variant="statusVariant" size="sm">
                            <span
                                class="mr-1.5 inline-block h-1.5 w-1.5 rounded-full"
                                :class="{
                                    'bg-emerald-500': statusVariant === 'emerald',
                                    'bg-amber-500': statusVariant === 'yellow',
                                    'bg-gray-400': statusVariant === 'gray',
                                }"
                                aria-hidden="true"
                            />
                            {{ statusLabel }}
                        </UiBadge>
                    </div>
                    <p v-if="subtitle" class="mt-1 text-xs text-gray-600">{{ subtitle }}</p>
                </div>
            </div>

            <div class="flex flex-wrap items-center gap-3">
                <span
                    v-if="summary"
                    class="inline-flex items-center rounded-md border border-gray-200 bg-gray-50 px-3.5 py-2 text-xs font-medium text-gray-700"
                >
                    {{ summary }}
                </span>
                <slot name="actions" />
            </div>
        </div>
    </header>
</template>
